import ChartTab from "./ChartTab";
import React from "react";

class ChartCompanyTabPure extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <ChartTab
        {...this.props}
        // defaultPageSize={computeDefaultTableSize(data, "family")}
        pivots={["family", "category"]}
        data={data}
        showColumns={["family", "tiers", "category"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}

        // visibleColumns={[
        //   {
        //     name: "category",
        //     id: "category",
        //     type: "string",
        //     accessor: d => d.category || "NA",
        //     maxWidth: 200
        //   }
        // ]}
      />
    );
  }
}

export default ChartCompanyTabPure;
